require('../modules/web.timers');
var path = require('../internals/path');

module.exports = path.setTimeout;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/set-timeout.js
// module id = 6423
// module chunks = 25